import dropperIcon from 'assets/images/ingredients/eyedropper.svg';
import phoneIcon from 'assets/images/ingredients/phone.svg';
import reviewAndRefineIcon from 'assets/images/ingredients/reviewAndRefine.svg';

const howWorksContent = {
  title: 'Custom care starts here',
  elements: [
    {
      title: `Take your online consultation`,
      contentHaircare:
        ' We’ll ask in-depth questions about your lifestyle and environment to understand what kind of care your hair needs.',
      contentSkincare:
        'We’ll ask in-depth questions about your lifestyle and environment to understand what kind of care your skin and hair need.',
      asset: {
        icon: phoneIcon,
        alt: 'Eyedropper',
      },
    },
    {
      title: `Get your custom formulas`,
      contentHaircare:
        'We’ll create personalized, made-to-order products formulated to support your unique needs at this moment in time.',
      contentSkincare:
        'We’ll create a set of personalized products formulated to support your unique needs at this moment in time.',
      asset: {
        icon: dropperIcon,
        alt: 'Smartphone',
      },
    },
    {
      title: `Review & refine™`,
      contentHaircare:
        'Share feedback on your formulas so we can provide evolving, custom-fitting care with every order.',
      contentSkincare: `Share feedback on your formulas after every order so we can provide evolving, custom-fitting care.`,
      asset: {
        icon: reviewAndRefineIcon,
        alt: 'Sparkles',
      },
    },
  ],
};

export default howWorksContent;
